import auth from "@/v2/utils/auth";
import { mainApi } from '@/v2/utils/api'

export default {
  toPointFixed,
  // 格式化时间戳
  formatDate (timestamp, type = "ymd") {
    if (!timestamp) {
      return "";
    }
    let date = new Date(timestamp);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;
    let h = date.getHours();
    h = h < 10 ? "0" + h : h;
    let i = date.getMinutes();
    i = i < 10 ? "0" + i : i;
    let s = date.getSeconds();
    s = s < 10 ? "0" + s : s;
    switch (type) {
      case "md":
        return `${m}-${d}`;
      case "ymd": {
        return `${y}-${m}-${d}`;
      }
      case "mdhi": {
        return `${m}-${d} ${h}:${i}`;
      }
      case "ymdhi": {
        return `${y}-${m}-${d} ${h}:${i}`;
      }
      case "hm": {
        return `${h}:${i}`;
      }
      default: {
        return `${y}-${m}-${d} ${h}:${i}:${s}`;
      }
    }
  },

  isAuth (name) {
    let result = auth.checkAuthPerm(name)
    if (!result) {
      // 这里判断pathArray，为了兼容新的权限是和业务逻辑相关的情况
      // 比如单科考试的“年级报告”，需要检查pathArray中是否包含“School-Report”
      // 而“School-Report”权限是和某个考试有关，需要根据考试id调用接口单独获取
      // 搜索标记：School-Report
      const pathArray = JSON.parse(YJ_SCHOOL_STORAGE.getItem("pathArray"));
      result = checkAuthPerm(name, pathArray, result);
    }
    return result
  },

  // 检查多个权限
  async isMoreAuth (name, moreAuths, params) {
    let result = false
    if (this.isEmpty(params) || this.isEmpty(params.ids.EXAM)) {
      return result
    }

    // 检测考试权限
    if (moreAuths.includes('exam')) {
      const res = await mainApi.getExamPerms(params)
      if (res.success) {
        params.ids.EXAM.forEach(examId => {
          const examPerms = res.body[examId]
          if (examPerms) {
            const pathArray = examPerms.map(item => item.permCode)
            if (pathArray.length > 0) {
              result = checkAuthPerm(name, pathArray, result);
              if (result) {
                return result
              }
            }
          }
        })
      }
    }

    return result
  },

  //根据对象某一key值做排序
  compare (property) {
    return function (obj1, obj2) {
      var value1 = obj1[property];
      var value2 = obj2[property];
      return value1 - value2; // 升序
    };
  },

  //对象数组去重
  objArrayReduce (objArray, key) {
    let hash = {};
    objArray = objArray.reduce(function (item, next) {
      hash[next[key]] ? "" : (hash[next[key]] = true && item.push(next));
      return item;
    }, []);
    return objArray;
  },

  // 生成随机字符串
  getRandomString (len) {
    const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = "";
    for (var i = len; i > 0; --i) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
  },
  TransformToChinese (num) {
    var a = numToChn(num);
    num = Math.floor(num);
    var unitPos = 0;
    var strIns = "",
      chnStr = "";
    var needZero = false;

    if (num === 0) {
      return chnNumChar[0];
    }
    while (num > 0) {
      var section = num % 10000;
      if (needZero) {
        chnStr = chnNumChar[0] + chnStr;
      }
      strIns = sectionToChinese(section);
      strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0];
      chnStr = strIns + chnStr;
      needZero = section < 1000 && section > 0;
      num = Math.floor(num / 10000);
      unitPos++;
    }

    return chnStr + a;
  },
  download: function (url) {
    const a = document.createElement('a');
    a.style.display = 'none';
    a.setAttribute('target', '_blank');
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  },
  // 转换年级
  convertGradeName (gradeNum) {
    if (gradeNameList.length >= gradeNum) {
      return gradeNameList[gradeNum - 1]
    }
    return '未知'
  },

  convertSubject (list) {
    const subjectList = []
    list.forEach(item => {
      item.isWai = false
      if (this.getIsWai(item.subjectId)) {
        item.isWai = true
        const curSubject = subjectList && subjectList.find(subject => subject.subjectId == 0)
        if (curSubject) {
          curSubject.children.push(item)
        } else {
          subjectList.push({
            dicCode: 0,
            dicName: '外语',
            subjectId: 0,
            isWai: true,
            children: [item]
          })
        }
      } else {
        subjectList.push(item)
      }
    })
    return subjectList
  },

  getIsWai (subjectId) {
    return foreignLanguage.indexOf(subjectId + '') > -1
  },

  // 标准化题号
  standardQuestionNumber (question) {
    return question.bigNum && question.smallNum ? question.bigNum + "." + question.smallNum : question.question ? `第${question.question}题` : question.num ? `第${question.num}题` : '--'
  },

  // 根据枚举Key获取指定枚举code
  getEnumCodeByKey (exam, key) {
    const object = exam[key]
    if (object) {
      return object.code
    }
    return -1
  },

  // 根据枚举code获取指定枚举值
  getKeyByValue (examEnum, value, kind) {
    return Object.keys(examEnum).find(key => {
      const obj = examEnum[key]
      if (obj) {
        return obj.code === value && obj.kind === kind
      }
    });
  },

  // 检测是否空值
  isEmpty (val) {
    if (typeof val === 'undefined' || val === null || val === '') {
      return true
    }
    return false
  },

  // 生成选项数据
  generateOptionData (num) {
    const length = optionList.length > num ? num : optionList.length
    let optionText = ''
    for (let i = 0; i < length; i++) {
      optionText += optionList[i] + '\n'
    }
    return optionText.trimEnd('\n')
  },

  // 获取选择数据
  getOptionData (num) {
    const length = optionList.length > num ? num : optionList.length
    return optionList[length].trim('')
  },
  coordinateAnalysis,
  coordinateListAnalysis,
  optionCoordinateAnalysis,
  coordinateExamNoItemAnalysis
};
function checkAuthPerm (name, pathArray, result) {
  if (Array.isArray(name)) {
    for (let index = 0; index < name.length; index++) {
      const element = name[index];
      if (pathArray && pathArray.indexOf(element) > -1) {
        result = true;
        break;
      }
    }
  } else {
    result = pathArray && pathArray.indexOf(name) > -1;
  }
  return result;
}

export function customFormDate (time, form = "yyyy-M-d h:m:s") {
  let date = new Date(parseInt(time));
  let y = date.getFullYear(); // 年
  let M = date.getMonth() + 1; //月
  let d = date.getDate(); //日
  let h = date.getHours(); //时
  let m = date.getMinutes(); //分
  let s = date.getSeconds(); //秒
  let formOf = {
    yyyy: y,
    M,
    MM: String(M).length == 1 ? "0" + M : M,
    d,
    dd: String(d).length === 1 ? "0" + d : d,
    h,
    hh: String(h).length === 1 ? "0" + h : h,
    m,
    mm: String(m).length === 1 ? "0" + m : m,
    s,
    ss: String(s).length === 1 ? "0" + s : s
  };
  let formChars = ["y", "M", "d", "h", "m", "s"];
  let formDate = "";
  // 准备一个 计算key
  let key = "";
  for (let i = 0; i < form.length; i++) {
    // 默认获取第一个字符
    key += form[i];
    // 如果能获取值
    if (formOf[key]) {
      // 判断是否加上下一个匹配字符  不能获取到值
      if (i + 1 < form.length && !formOf[key + form[i + 1]]) {
        formDate += formOf[key];
        key = "";
      } else {
        // 如果已经到了最后一个匹配字符了,就不用判断下一个
        if (i === form.length - 1) {
          formDate += formOf[key];
          key = "";
        } else continue; // 如果不是最后一个,并加上最下一个字符能匹配到值
      }
    } else {
      // 如果第一个默认字符没匹配到值,并在匹配字符内(跳过)
      if (formChars.includes(form[i])) {
        continue;
      } else {
        // 如果不在匹配字符内直接插入并初始化key
        formDate += key;
        key = "";
      }
    }
  }
  return formDate;
}
var chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
var chnUnitSection = ["", "万", "亿", "万亿", "亿亿"];
var chnUnitChar = ["", "十", "百", "千"];
// 外语集合[3:英语，21：日语，22：俄语，27：德语，28：法语，29：西班牙语]
var foreignLanguage = ['3', '21', '22', '27', '28', '29'];
var optionList = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

export const examTypeList = [
  "学前",
  "周练",
  "单元",
  "月测",
  "期中",
  "期末",
  "模拟",
  "其它"
];
export const gradeNameList = [
  "一年级",
  "二年级",
  "三年级",
  "四年级",
  "五年级",
  "六年级",
  "初一",
  "初二",
  "初三",
  "高一",
  "高二",
  "高三"
];

var numToChn = function (num) {
  var index = num.toString().indexOf(".");
  if (index != -1) {
    var str = num.toString().slice(index);
    var a = "点";
    for (var i = 1; i < str.length; i++) {
      a += chnNumChar[parseInt(str[i])];
    }
    return a;
  } else {
    return "";
  }
};
//定义在每个小节的内部进行转化的方法，其他部分则与小节内部转化方法相同
function sectionToChinese (section) {
  var str = "",
    chnstr = "",
    zero = false,
    count = 0; //zero为是否进行补零， 第一次进行取余由于为个位数，默认不补零
  while (section > 0) {
    var v = section % 10; //对数字取余10，得到的数即为个位数
    if (v == 0) {
      //如果数字为零，则对字符串进行补零
      if (zero) {
        zero = false; //如果遇到连续多次取余都是0，那么只需补一个零即可
        chnstr = chnNumChar[v] + chnstr;
      }
    } else {
      zero = true; //第一次取余之后，如果再次取余为零，则需要补零
      str = chnNumChar[v];
      str += chnUnitChar[count];
      chnstr = str + chnstr;
    }
    count++;
    section = Math.floor(section / 10);
  }
  return chnstr;
}

// 浮点数精确保留n位, 整数不会出现浮点
function toPointFixed (value, fixValue = 2) {
  const target = parseFloat(value).toFixed(fixValue)
  if (target.indexOf('.') === -1) return value
  const values = target.split('.')
  let num = parseInt(values[1]) // 看看小数的整型
  if (num > 10 || num === 0) { // 将小数如9.10、9.00中的0去掉
    num = values[1].replace('0', '').replace('0', '') // 9.00时，num的长度为0
  } else {
    num = values[1] // 保留 9.01的01情况
  }
  if (num.length > 0) {
    return values[0] + '.' + num
  } else {
    return values[0]
  }
}

// 选项坐标解析
function optionCoordinateAnalysis (object) {
  try {
    if (!object) {
      return null
    }
    const optionList = []
    const optionObj = JSON.parse(object)
    for (const item of optionObj) {
      optionList.push({
        option: item.value,
        ...coordinateAnalysis(item.coordinate, true)
      })
    }
    return optionList
  } catch (error) {
    return null
  }
}

// 坐标解析
function coordinateAnalysis (coordinate, isShift = false) {
  if (!coordinate) {
    return {}
  }
  let list = coordinate.split(",");
  if (isShift) {
    list.shift();
  }

  const coordinateItem = {}
  for (const item of list) {
    const obj = item.split('_')
    coordinateItem[obj[0]] = obj[1]
  }
  return coordinateItem;
}

// 坐标集合解析
function coordinateListAnalysis (coordinateList, isShift = false) {
  if (!coordinateList) {
    return []
  }

  const list = [];
  coordinateList.split(";").forEach(item => {
    list.push(coordinateAnalysis(item, isShift))
  })

  return list
}

// 考号集合解析
function coordinateExamNoItemAnalysis (coordinateList, key, isShift = false) {
  if (!coordinateList) {
    return []
  }

  let parsedList;
  try {
    parsedList = JSON.parse(coordinateList);
  } catch (e) {
    console.error("Invalid JSON format:", e);
    return [];
  }

  if (!Array.isArray(parsedList)) {
    console.error("Parsed JSON is not an array.");
    return [];
  }
  const list = [];
  for (const item of parsedList) {
    if (Array.isArray(item)) {
      // 如果 item 是数组，则遍历其元素
      for (const subItem of item) {
        list.push(coordinateAnalysis(subItem[key], isShift));
      }
    } else {
      // 否则直接处理 item
      list.push(coordinateAnalysis(item[key], isShift));
    }
  }


  return list
}

